export type VasAccessState =
  | { status: 'loading' }
  | { status: 'allowed'; msisdnMasked?: string; subscription?: string }
  | { status: 'denied'; message: string; subscribeUrl: string }
  | { status: 'error'; message: string; subscribeUrl: string };

const DEFAULT_SUBSCRIBE = 'https://playhub.co.ke/c/nganya';

function sessionUrl(): string {
  return import.meta.env.VITE_NGANYA_SESSION_URL || '/api/nganya/session';
}

function defaultSubscribeUrl(): string {
  return import.meta.env.VITE_PLAYHUB_SUBSCRIBE_URL || DEFAULT_SUBSCRIBE;
}

/**
 * First-party Playhub gate. Server consumes vas_token on landing and sets a session;
 * this client only asks whether access is still live (subscription entitlement).
 */
export async function fetchVasAccess(): Promise<VasAccessState> {
  const subscribeUrl = defaultSubscribeUrl();

  // Local/dev bypass when explicitly enabled (never on production builds without the flag).
  if (import.meta.env.VITE_NGANYA_DEV_UNLOCK === '1') {
    return { status: 'allowed', msisdnMasked: 'dev' };
  }

  try {
    const res = await fetch(sessionUrl(), {
      method: 'GET',
      credentials: 'include',
      headers: { Accept: 'application/json' },
    });
    const body = (await res.json().catch(() => ({}))) as {
      ok?: boolean;
      access?: boolean;
      message?: string;
      subscribe_url?: string;
      msisdn_masked?: string;
      subscription?: string;
    };

    if (res.ok && body.ok && body.access) {
      return {
        status: 'allowed',
        msisdnMasked: body.msisdn_masked,
        subscription: body.subscription,
      };
    }

    return {
      status: 'denied',
      message: body.message || 'Subscribe on Playhub to play Nganya.',
      subscribeUrl: body.subscribe_url || subscribeUrl,
    };
  } catch {
    return {
      status: 'error',
      message: 'Could not verify Playhub access. Check your connection and try again.',
      subscribeUrl,
    };
  }
}

export async function logoutVasAccess(): Promise<void> {
  try {
    await fetch(import.meta.env.VITE_NGANYA_LOGOUT_URL || '/api/nganya/logout', {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
  } catch {
    // ignore
  }
}
